const home = {
  'hero.eyebrow': 'Centrum zasobów USFans',
  'hero.title': 'USFans Spreadsheet — Znajdź produkty, sprzedawców i zasoby zakupowe szybciej',
  'hero.subtitle': 'Poznaj zasoby arkuszy USFans, listy produktów, informacje o sprzedawcach, opinie, poradniki wysyłkowe i praktyczne zasoby zakupowe w jednym uporządkowanym miejscu.',
  'hero.primaryCta': 'USFans Spreadsheet',
  'hero.secondaryCta': 'Kup Teraz',
  'hero.trust': 'Niezależne źródło • Regularnie aktualizowane • Stworzone dla łatwiejszego wyszukiwania produktów',

  'category.browse': 'Przeglądaj kategorie',
  'category.label': 'Wybierz kategorię',
  'category.all': 'Wszystkie kategorie',
  'category.hint': 'Przejdź bezpośrednio do kategorii produktów na głównej stronie.',

  'categories.shoes': 'Buty',
  'categories.hoodies': 'Bluzy / Swetry',
  'categories.tshirts': 'Koszulki',
  'categories.jackets': 'Kurtki',
  'categories.pants': 'Spodnie / Szorty',
  'categories.headwear': 'Nakrycia głowy',
  'categories.sets': 'Zestawy',
  'categories.underwear': 'Bielizna',
  'categories.jersey': 'Koszulki sportowe',
  'categories.accessories': 'Akcesoria',
  'categories.bags': 'Torby',
  'categories.belts': 'Paski',
  'categories.perfumes': 'Perfumy',
  'categories.other': 'Inne rzeczy',

  'whatis.title': 'Czym jest arkusz USFans Spreadsheet?',
  'whatis.copy': 'Arkusz USFans pomaga uporządkować informacje o produktach, zasoby sprzedawców i przydatne odnośniki zakupowe w jednym miejscu. Naszym celem jest ułatwienie wyszukiwania produktów poprzez uporządkowanie istotnych zasobów USFans w przeszukiwalne kategorie, poradniki i porównania.',
  'whatis.cta': 'Poznaj centrum arkuszy',

  'why.title': 'Wszystko, czego potrzebujesz do mądrzejszego wyszukiwania USFans',
  'why.subtitle': 'Uporządkowane zasoby, które pomogą Ci pewniej badać produkty i sprzedawców.',
  'why.card1.title': 'USFans Spreadsheet',
  'why.card1.desc': 'Znajdź uporządkowane zasoby produktów i sprzedawców w jednym miejscu.',
  'why.card2.title': 'Katalog sprzedawców',
  'why.card2.desc': 'Poznaj informacje o sprzedawcach i poradniki badawcze.',
  'why.card3.title': 'Poradniki produktowe',
  'why.card3.desc': 'Odkryj wskazówki badawcze dla konkretnych kategorii.',
  'why.card4.title': 'Opinie USFans',
  'why.card4.desc': 'Zrozum ważne czynniki przed skorzystaniem z usługi lub zasobu.',
  'why.card5.title': 'Poradniki wysyłkowe',
  'why.card5.desc': 'Dowiedz się o kosztach, metodach i kwestiach związanych z wysyłką.',
  'why.card6.title': 'Centrum bezpieczeństwa',
  'why.card6.desc': 'Naucz się rozpoznawać podejrzane linki, oferty i typowe zagrożenia.',

  'popular.title': 'Popularne wyszukiwania USFans',
  'popular.subtitle': 'Poznaj tematy, których ludzie najczęściej szukają przy badaniu zasobów USFans.',
  'popular.1': 'Opinie USFans',
  'popular.2': 'Koszt wysyłki USFans',
  'popular.3': 'Kupon USFans',
  'popular.4': 'Kod rabatowy USFans',
  'popular.5': 'Magazyn USFans',
  'popular.6': 'Czy USFans jest legalne?',
  'popular.7': 'USFans Spreadsheet',
  'popular.8': 'Poradnik sprzedawcy USFans',

  'compare.title': 'Porównaj zasoby USFans, zanim zdecydujesz',
  'compare.subtitle': 'Szybka pomoc w zrozumieniu, do czego służy każdy zasób. Nigdy nie wymyślamy ocen, cen ani roszczeń weryfikacyjnych.',
  'compare.col.resource': 'Zasób',
  'compare.col.category': 'Kategoria',
  'compare.col.info': 'Do czego służy',
  'compare.row1.resource': 'USFans Spreadsheet',
  'compare.row1.category': 'Badanie',
  'compare.row1.info': 'Porządkowanie informacji o produktach i sprzedawcach',
  'compare.row2.resource': 'Katalog sprzedawców',
  'compare.row2.category': 'Sprzedawcy',
  'compare.row2.info': 'Wskazówki dotyczące badania i weryfikacji sprzedawców',
  'compare.row3.resource': 'Poradniki produktowe',
  'compare.row3.category': 'Produkty',
  'compare.row3.info': 'Wskazówki dotyczące badania produktów w kategoriach',
  'compare.row4.resource': 'Poradniki wysyłkowe',
  'compare.row4.category': 'Wysyłka',
  'compare.row4.info': 'Metody, koszty i kwestie związane z wysyłką',
  'compare.row5.resource': 'Centrum bezpieczeństwa',
  'compare.row5.category': 'Bezpieczeństwo',
  'compare.row5.info': 'Świadomość ryzyka i bezpieczne przeglądanie',

  'article.faqTitle': 'Często zadawane pytania',
  'guides.title': 'Poradniki i samouczki USFans',
  'guides.subtitle': 'Oryginalne, szczegółowe poradniki, które pomogą Ci skuteczniej badać produkty i sprzedawców.',
  'guides.updated': 'Zaktualizowano',
  'guides.minRead': 'min czytania',
  'guides.category.guide': 'Poradnik',
  'guides.category.review': 'Opinia',
  'guides.category.shipping': 'Wysyłka',

  'safety.title': 'Bądź bezpieczniejszy podczas badania zasobów USFans',
  'safety.copy': 'Zawsze weryfikuj niezależnie strony internetowe, sprzedawców, linki, informacje o płatnościach i szczegóły produktów. Nasze Centrum Bezpieczeństwa wyjaśnia typowe zagrożenia, w tym podejrzane strony, linki phishingowe, wprowadzające w błąd promocje i niebezpieczne praktyki przeglądania.',
  'safety.cta': 'Odwiedź Centrum Bezpieczeństwa',
  'safety.point1': 'Weryfikuj niezależnie strony i linki',
  'safety.point2': 'Nigdy nie udostępniaj nieostrożnie danych płatności ani konta',
  'safety.point3': 'Uważaj na wprowadzające w błąd promocje i fałszywe oferty',
  'safety.point4': 'Zbadaj sprzedawców przed podjęciem decyzji',

  'final.title': 'Gotowy, aby poznać USFans Spreadsheet?',
  'final.copy': 'Zacznij od Centrum USFans Spreadsheet, porównaj przydatne zasoby i poznaj praktyczne poradniki, które sprawią, że Twoje badania będą szybsze i łatwiejsze.',
  'final.cta': 'Poznaj USFans Spreadsheet',
  'final.secondary': 'Odwiedź stronę główną',
};

export default home;